import { useState, useEffect } from "react";
import { Menu as MenuIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Toolbar,
  AppBar as MuiAppBar,
  Box,
  Typography,
  MenuItem,
  Menu,
} from "@mui/material";
import { Route, Routes, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useDispatch, useSelector } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import { startAuthUserLogout } from "../../Store/UsersAccount/userAccount.slice.selector";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const NavBar = (props) => {
  const { open, handleDrawerOpen } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [trustId, setTrustId] = useState("");
  const [auth, setAuth] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleChange = (event) => {
    setTrustId(event.target.value);
    // navigate("/users")
    // dispatch(
    //   setLoginUserType({ userType: "trust", trust_code: event.target.value })
    // );
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    dispatch(startAuthUserLogout())
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={"Home"} />
              <Route path="list-Users/*" element={"Manage Users"} />
              <Route path="manage-Apis/*" element={"Manage API's"} />
              <Route path="manage-Roles/*" element={"Manage Roles"} />
              <Route path="manage-Templates/*" element={"Manage Templates"} />
              <Route path="manage-Documents/*" element={"Manage Documents"} />
              <Route path="manage-Profile/*" element={"Manage Profile"} />
            </Routes>
          </Typography>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  navigate("manage-Profile");
                  handleClose();
                }}
              >
                Profile
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("manage-Profile/change-password");
                  handleClose();
                }}
              >
                Change Password
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("manage-Profile/add-security-question");
                  handleClose();
                }}
              >
                Add Security Question
              </MenuItem>
              <MenuItem
                sx={{}}
                onClick={handleLogOut}
              >
                <LogoutIcon
                  size="small"
                  color="error"
                  sx={{ marginRight: "5px" }}
                />
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default NavBar;
